import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { ReadonlyItem } from '@/components';
import { BankId } from '@/model/common';
import { makeSelectBank, makeSelectDefaultBank } from '@/model/dictionary/selectors';
import { RootState } from '@/model/types';
import { makeSelectReceiverBank } from '@/model/withdrawal/selectors';

export interface BankReadonlyValueProps {
  'data-test'?: string;
  value?: BankId;
  label?: string;
  isCredit?: boolean;
}

const BankReadonlyValue: React.FC<BankReadonlyValueProps> = ({ isCredit, value, label, 'data-test': dataTest }) => {
  const selectBank = useMemo(
    () =>
      value && !label
        ? (state: RootState): { id: string; name: string } | undefined => {
            const bank = makeSelectBank(value)(state);
            const defaultBank = makeSelectDefaultBank()(state);
            const receiverBank = makeSelectReceiverBank(value)(state);
            // prettier-ignore
            // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
            return (bank
            || (receiverBank
              ? { id: receiverBank.id, name: receiverBank.name }
              : undefined)
            || (defaultBank ? { id: value, name: value } : undefined)
          );
          }
        : (): undefined => undefined,
    [label, value],
  );
  const bank = useSelector(selectBank);
  return (
    <ReadonlyItem
      data-test={dataTest}
      label={
        isCredit ? (
          <FormattedMessage id="withdrawal.fields.bank.label.receiver" />
        ) : (
          <FormattedMessage id="withdrawal.fields.bank.label.sender" />
        )
      }
      textClassName="ym-hide-content"
    >
      {bank?.name || label}
    </ReadonlyItem>
  );
};

export default BankReadonlyValue;
